// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"761":"9867e5d4","787":"90818243"}[chunkId] + ".chunk.js";
};